import { useIntl, history } from 'umi';
import { v4 as uuidv4 } from 'uuid';
import { useRequestController } from './useRequestController.ts';
import { DSAgentModelResponse } from '@/pages/aigc/pages/Agent/service/service';
import { useMemo } from 'react';

export interface SelectedDsModelType {
  index: number;
  name: string;
  modelId: string;
  modelName: string;
  locale: string;
  startupPrompt: string;
}

// 默认空数据，用于错误时回退
const DEFAULT_DS_AGENT_DATA: DSAgentModelResponse['agent_models'][] = [];

const useDSAgentData = () => {
  const { locale } = useIntl();
  // 失败回调处理
  const { data, loading, mutate, refetch } = useRequestController({
    method: 'POST',
    url: `/api/agent_com/get_agent_models`,
    refreshDeps: useMemo(() => ({
      trace_id: uuidv4(),
      agent_type: 'ds_agent',
      system_language: locale,
    }), [locale]),
    httpCfg: {
      original: true,
      ignoreCode: true,
    },
    leaveRequest: true,
    // 30min 内绝不重发：cacheTime + staleTime 双配，缺一不可
    cacheTime: 1800000,
    staleTime: 1800000,
    cacheKey: `ds-agent-models-${locale}`,
    // 成功回调兜底
    onSuccess: (response: any, mutateFunc?: (data: any) => void) => {
      // 数据有效性校验兜底
      if (!response) {
        mutateFunc?.(DEFAULT_DS_AGENT_DATA);
        return;
      }
      // 特殊错误码处理：1005 跳转404
      if (response?.res_code === 1005) {
        history.push('/agent/404');
        return;
      }
    },
    // 失败回调兜底
    onError: () => {
      mutate?.(DEFAULT_DS_AGENT_DATA);
    },
  });

  return {
    dSExpertAgent: data?.data?.agent_models,
    loading,
    refetch,
    mutate,
  };
};

export default useDSAgentData;